import { useContext } from 'react';
import { ModalContext } from '../../contexts/ModalContext';

export default function FailedPaymentModal(props: {content?: string}) {
  const { handleModal } = useContext(ModalContext);

  const onClickClose = () => {
    handleModal();
  };

  return (
    <div className="w-[328px] rounded-lg bg-N10 text-N0 flex flex-col p-4 items-center">
      <div className=" text-[22px] font-bold">결제 실패</div>
      <div className="mb-4">
        { props?.content ? 
          props.content : `결제를 실패하였습니다.<br />고객센터에 문의해주세요.`
        }
      </div>
      <button className="w-full h-12 rounded bg-N5 text-N9" onClick={() => onClickClose()}>
        확인
      </button>
    </div>
  );
}